var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useState } from 'react';
import { render } from 'react-dom';
import styles from './index.less';
import { nextTicket } from '@tencent/dz-models';
var add;
var UIMessage = function () {
    var _a = useState([]), list = _a[0], setList = _a[1];
    var remove = function (val) {
        setList(function (current) { return current.filter(function (item) { return item.key !== val.key; }); });
    };
    add = function (val) {
        setList(function (current) {
            var newList = __spreadArray(__spreadArray([], current, true), [val], false);
            setTimeout(function () {
                remove(val);
            }, 5000);
            return newList;
        });
    };
    useEffect(function () {
        if (list.length > 5) {
            setList(function (current) {
                current.shift();
                return current;
            });
        }
    }, [list]);
    return (React.createElement("div", { className: styles['message-wrap'], id: "message" }, list.map(function (item) { return (React.createElement("div", { className: styles.message + " " + styles["" + item.type] + " ", key: item.key },
        React.createElement("div", null, item.content))); })));
};
var Message = (function () {
    var getKey = function () {
        var id = new Date().getTime();
        var rand = Math.floor(Math.random() * 100);
        return "" + id + rand;
    };
    var messageHander = function (type) {
        if (type === void 0) { type = 'error'; }
        return function (content) {
            add({
                content: content,
                key: getKey(),
                type: type,
            });
        };
    };
    nextTicket(function () {
        var container = document.querySelector('#messageWrapper');
        if (!container) {
            container = document.createElement('div');
            container.id = 'messageWrapper';
            document.body.appendChild(container);
        }
        render(React.createElement(UIMessage, null), container);
    });
    return {
        error: messageHander('error'),
        success: messageHander('success'),
        info: messageHander('info'),
        warn: messageHander('warn'),
    };
})();
export { Message };
